module.exports = __webpack_public_path__ + "static/alena-46aef1e337c95b197980ff012c7d01f7.png";